import React from 'react';
import styles from './Reviews.module.css';
import useReveal from './useReveal';

const reviews = [
  {
    stars: 5,
    text: '"404 Stack helped us build a modern website and significantly improved our online visibility through strategic SEO and digital marketing."',
    author: 'Verified Client · Web Development',
  },
  {
    stars: 5,
    text: '"Their Google Ads campaigns significantly increased our leads and customer inquiries. ROI was well beyond our expectations."',
    author: 'Verified Client · Google Ads',
  },
  {
    stars: 5,
    text: '"The team understands both technology and business growth. They are not just a vendor — they are a true long-term partner."',
    author: 'Verified Client · Full Stack',
  },
];

export default function Reviews() {
  const headRef = useReveal();

  return (
    <section className={styles.section}>
      <div className={`reveal ${styles.head}`} ref={headRef}>
        <span className="section-label">// client reviews</span>
        <h2 className="section-title">What Our <em>Clients</em> Say</h2>
      </div>
      <div className={styles.grid}>
        {reviews.map((r, i) => (
          <ReviewCard key={i} review={r} />
        ))}
      </div>
    </section>
  );
}

function ReviewCard({ review }) {
  const ref = useReveal();
  return (
    <div className={`reveal ${styles.card}`} ref={ref}>
      <div className={styles.stars}>{'★'.repeat(review.stars)}</div>
      <p className={styles.text}>{review.text}</p>
      <span className={styles.author}>{review.author}</span>
    </div>
  );
}
